import React from 'react';
import { GuestSide } from '../types/invitation';

interface GuestSideTagProps {
  guestSide: GuestSide;
  onToggle?: () => void;
  readonly?: boolean;
}

const GuestSideTag: React.FC<GuestSideTagProps> = ({ guestSide, onToggle, readonly = false }) => {
  // 男方徽章顏色選項 - 提供4種選擇
  const groomColorOptions = {
    gold: {
      bg: 'bg-wedding-gold',
      hover: 'hover:bg-wedding-gold/80',
      focus: 'focus:ring-wedding-gold',
      dot: 'bg-amber-200'
    },
    blue: {
      bg: 'bg-blue-600',
      hover: 'hover:bg-blue-700',
      focus: 'focus:ring-blue-600',
      dot: 'bg-blue-200'
    },
    purple: {
      bg: 'bg-purple-600',
      hover: 'hover:bg-purple-700',
      focus: 'focus:ring-purple-600',
      dot: 'bg-purple-200'
    },
    teal: {
      bg: 'bg-teal-600',
      hover: 'hover:bg-teal-700',
      focus: 'focus:ring-teal-600',
      dot: 'bg-teal-200'
    }
  };

  // 目前使用金色作為預設，未來可以從props或context中選擇
  // 其他可選顏色：groomColorOptions.blue, groomColorOptions.purple, groomColorOptions.teal
  const currentGroomColor = groomColorOptions.teal;

  const brideColor = {
    bg: 'bg-wedding-pink',
    hover: 'hover:bg-wedding-pink/80',
    focus: 'focus:ring-wedding-pink',
    dot: 'bg-pink-200'
  };

  const activeColor = guestSide === 'bride' ? brideColor : currentGroomColor;

  return (
    <button
      onClick={readonly ? undefined : onToggle}
      disabled={readonly}
      className={`
        relative inline-flex items-center px-3 py-1 text-xs font-normal rounded-full transition-all duration-200 whitespace-nowrap
        ${activeColor.bg} text-white shadow-sm
        ${readonly ? 'cursor-default opacity-80' : `${activeColor.hover} hover:shadow-md cursor-pointer`}
        focus:outline-none ${readonly ? '' : `focus:ring-2 focus:ring-offset-2 ${activeColor.focus}`}
      `}
    >
      <span className={`w-2 h-2 rounded-full mr-1 ${activeColor.dot}`} />
      <span>{guestSide === 'bride' ? '女方' : '男方'}</span>
    </button>
  );
};

export default GuestSideTag;